import React from "react";
import { NextPage } from "next";
import { Container } from "@material-ui/core";
import { createGetServerSideProps, StaticPageProps } from "evcharging/app";
import { I18nPage } from "i18n/types/pages.enum";
import PrivacyPolicy from "containers/common/sections/privacy";
import { Page } from "containers/common/sections/layout";

const Privacy: NextPage<StaticPageProps> = ({ page }) => {
  return (
    <Page title={page.meta_title} description={page.meta_description} locales={page.locales}>
      <Container>
        <PrivacyPolicy />
      </Container>
    </Page>
  );
};

export const getServerSideProps = createGetServerSideProps(undefined, undefined, [I18nPage.Privacy]);

export default Privacy;
